import { useState, type ReactNode } from "react";
import { AppTopbar } from "@/components/AppTopbar";
import { CoursesCatalogDrawer } from "@/components/CoursesCatalogDrawer";

/** Shared chrome for the Profile hub tabs (My Training / Account / Privacy):
 *  one topbar + drawer wiring, one container width, one page-title style — so
 *  every tab looks consistent and the pages stay free of boilerplate. */
export function ProfileLayout({ title, children }: { title?: string; children: ReactNode }): JSX.Element {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <AppTopbar onOpenDrawer={() => setDrawerOpen(true)} />
      <CoursesCatalogDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <main className="p-4 sm:p-8 max-w-5xl mx-auto">
        {title && <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl mb-6">{title}</h1>}
        {children}
      </main>
    </>
  );
}
